import i18next from 'app/translations/i18n';

// Los idiomas de interfaz son los únicos con bundle de traducción en los frontales; el resto de
// filas de `langs` son versiones de contenido con id hex generado por POST /langs.
export const UI_LANGUAGE_IDS = ['es', 'en', 'pt', 'ca', 'eu', 'gl', 'mx', 'vl'];

export function isUiLanguage(lang) {
  return typeof lang?.id === 'string' && UI_LANGUAGE_IDS.includes(lang.id.toLowerCase());
}

export function isLangForUi(lang) {
  return Number(lang?.is_for_ui) === 1;
}

export function isUiCapableLang(lang) {
  return isUiLanguage(lang) || isLangForUi(lang);
}

// Un nombre en blanco no es un nombre: el catálogo lo rechazaría y la fila quedaría sin identificar.
export function isLangNameEmpty(lang) {
  return !lang?.description?.trim();
}

export function getUiLangsSummary(langs = []) {
  const uiLangs = langs.filter(isUiCapableLang);

  return {
    activeUiLangsCount: uiLangs.filter(isLangForUi).length,
    contentLangs: langs.filter((lang) => !isUiCapableLang(lang)),
    uiLangs,
  };
}

// Payload mínimo para el PATCH: `langs` arrastra campos que no son del recurso (description ya
// parseada por el duck, newItem) y reenviarlos los persistiría en base de datos.
export function getLangChanges(current, original) {
  const changes = {};

  if (current.description !== original.description) {
    changes.description = current.description;
  }

  if (isLangForUi(current) !== isLangForUi(original)) {
    changes.is_for_ui = isLangForUi(current) ? 1 : 0;
  }

  return changes;
}

// `description` es texto libre editable por la editorial ("Spanish 2"), así que el nombre del
// idioma se traduce por código al idioma de la interfaz y solo cae a la descripción si no existe.
export function getLangLabel(lang, t) {
  const id = typeof lang?.id === 'string' ? lang.id.toLowerCase() : '';

  return t(`languages:${id}`, { defaultValue: '' }) || lang?.description || '';
}

export function compareLangsByLabel(t) {
  return (a, b) => getLangLabel(a, t).localeCompare(getLangLabel(b, t), i18next.language);
}

export function parseLanguages(languages = [], isFilter = false) {
  if (isFilter) {
    languages = languages.filter(isLangForUi);
  }

  // Solo los idiomas de interfaz tienen nombre canónico que traducir. La `description` de una
  // versión de contenido es texto libre que se edita y se persiste tal cual: traducirla mostraría
  // un valor distinto del guardado y una edición posterior lo escribiría de vuelta en el catálogo.
  return languages.map((language) => {
    return {
      ...language,
      description: isUiCapableLang(language) ? i18next.t(`languages:${language.description}`) : language.description,
    };
  });
}
